import { render } from "./AddEditSuperAdminEventTemplate.vue?vue&type=template&id=d1e2a418"
import script from "./AddEditSuperAdminEventTemplate.vue?vue&type=script&lang=js"
export * from "./AddEditSuperAdminEventTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__